import React from 'react';
import useFilterModalContext from '../../useFilterModalContext';
import useSearchParams from '../../../../useSearchParams';
import {XMarkIcon, ArrowRightIcon} from '@heroicons/react/20/solid';
import {useOpenWorkflowsQuery} from 'api';
import usePools from 'hooks/usePools';

export default () => {
  const {setFilterType} = useFilterModalContext();
  const {query, setQuery} = useSearchParams();
  const {defaultPool} = usePools();

  const {data: {openWorkflows = []} = {}} = useOpenWorkflowsQuery({
    variables: {poolUuid: defaultPool.uuid},
    fetchPolicy: 'cache-and-network',
    skip: !defaultPool,
  });

  if (!query?.workflowIds || !query.workflowIds.length) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">ワークフロー</h4>
        <button
          onClick={() => setFilterType('workflow')}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <ArrowRightIcon className="w-3 h-3 text-c-light" />
        </button>
        <button
          onClick={() => setQuery({...query, workflowIds: []})}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <XMarkIcon className="w-3 h-3 text-c-light" />
        </button>
      </div>
      <div className="flex flex-wrap gap-1">
        {openWorkflows
          .filter((workflow) => query.workflowIds.includes(workflow.id))
          .map((workflow) => (
            <span
              key={workflow.id}
              className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
              {workflow.name}
            </span>
          ))}
      </div>
    </div>
  );
};
